import { Grid } from '@mui/material';
import React, { useEffect, useState, useContext } from 'react';
import KenFieldContent from '../KenFieldContent';
import { FormContext } from '../../../../../../Context/formContext';
import { useFormContext } from 'react-hook-form';
import { getSplitName } from '../../../../../../Utils/Helpers/stringHelper';

function KenSectionContent(props) {
  const { fields, onFormSubmit, formJSON, activeStep } = props;
  const { formState, formDispatch } = useContext(FormContext);
  const [values, setValues] = useState();
  const methods = useFormContext(); // Gets context from FormProvider

  useEffect(() => {
    if (formState?.formData) {
      let obj = {};
      for (const key in formState?.formData) {
        if (formState?.formData.hasOwnProperty(key)) {
          obj[key] = formState?.formData[key];
        }
      }
      setValues(obj);
    }
  }, [formState]);

  const getFieldValue = (field) => {
    if (!field) return '';
    try {
      const name = 'values[' + field?.name + ']';
      const keysArray = getSplitName(name, '', true) || [];
      let str = '';
      keysArray.map((item, index) => {
        str = index === 0 ? item : `${str}['${item}'] && ${str}['${item}']`;
      });
      str = 'values && ' + str;
      return eval(str);
    } catch (err) {
      console.log('error in eval', err);
    }
  };

  return (
    <form id={`form-step${activeStep}`} onSubmit={onFormSubmit}>
      <Grid container spacing={6} rowSpacing={4}>
        {fields?.map((field, index) => {
          let conditionalField;
          let isConditionMatching = true;

          if (field.conditional) {
            try {
              conditionalField = formJSON
                ?.find((s) => field.condition.stepId === s.stepId)
                ?.sections.find((sec) => field.condition.sectionId === sec.sectionId)
                ?.fields.find((f) => field.condition.fieldId === f.fieldId);
            } catch (err) {
              console.log('err in searching conditional field', field.condition.fieldId, err);
              return true;
            }

            switch (field?.condition?.conditionType?.operation) {
              case 'equals':
                isConditionMatching = getFieldValue(conditionalField) === field.condition.conditionType.value;
                break;
              case 'lessThan':
                isConditionMatching = getFieldValue(conditionalField) < field.condition.conditionType.value;
                break;
              case 'greaterThan':
                isConditionMatching = getFieldValue(conditionalField) > field.condition.conditionType.value;
                break;
              case 'lessThanEqual':
                isConditionMatching = getFieldValue(conditionalField) <= field.condition.conditionType.value;
                break;
              case 'greaterThanEqual':
                isConditionMatching = getFieldValue(conditionalField) >= field.condition.conditionType.value;
                break;
              case 'true':
                isConditionMatching = true;
                break;
              default:
                break;
            }
          }

          return field.conditional ? (
            isConditionMatching && field?.condition?.control?.display && (
              <KenFieldContent
                key={field.name}
                {...field}
                {...props}
                lastItem={fields.length - 1 === index}
                register={methods.register}
              />
            )
          ) : (
            <KenFieldContent
              key={field.name}
              {...field}
              {...props}
              lastItem={fields.length - 1 === index}
              register={methods.register}
            />
          );
        })}
      </Grid>
    </form>
  );
}

export default KenSectionContent;
